<script setup lang="ts">
import { useMediaUrl } from "@/composables"
import Flickity from "flickity"
import type { Ref } from "vue"
import { onMounted, onUnmounted, ref } from "vue"
import CmsButtonLink from "./CmsButtonLink.vue"

const props = defineProps<{
    element: any
}>()

function attached() {
    containerElement.value.style.width = containerElement.value.getBoundingClientRect().width + "px"
    setTimeout(() => {
        if (!containerElement.value) {
            return
        }

        flickity.value = new Flickity(containerElement.value, {
            wrapAround: true,
            pageDots: false,
        })
    }, 1000)
}

function detached() {
    if (flickity.value) {
        flickity.value.destroy()
    }
}

const flickity: Ref<Flickity> = ref(null)
const containerElement: Ref<HTMLDivElement> = ref(null)
const { mediaUrl } = useMediaUrl()

onMounted(() => attached())
onUnmounted(() => detached())
</script>

<template>
    <div class="big-picture" :style="'background-image: url(' + mediaUrl(props.element.fileName)">
        <div class="main-carousel" ref="containerElement">
            <div class="carousel-cell" v-for="slide in props.element?.columns[0]">
                <div class="big-picture-content">
                    <h2>{{ slide.title }}</h2>

                    <div v-html="slide.text"></div>

                    <div class="mt-4" v-if="slide.buttonText">
                        <CmsButtonLink class="btn btn-primary" :element="slide"></CmsButtonLink>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
